import { Tabs, Tab, Box } from "@mui/material";
import React from "react";
import { CustomTabPanel, a11yProps } from "../../components/TabPanel/TabPanel";
import ReviewAttendance from "./ReviewAttendance";
import AddAttendance from "./AddAttendance";
import Footer from "../../components/Page Component/Footer";
import Navbar from "../../components/Page Component/Navbar";

const ViewAttendaceRecords = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const roleOfEmployee = localStorage.getItem("role");

  const handleTabChange = (value: number) => {
    setValue(value);
  };

  return (
    <Box sx={{ width: "100%", mt: 10, mb: 10 }}>
  {/* Centered Horizontal Tabs */}
  <Box sx={{ display: "flex", justifyContent: "center", width: "100%", mb: 2 }}>
    <Box sx={{ maxWidth: "1200px", width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="Attendance Tabs"
        textColor="inherit"
        indicatorColor="secondary"
        centered
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          minHeight: 0,
          "& .MuiTabs-flexContainer": {
            justifyContent: "center",
          },
          "& .MuiTab-root": {
            minHeight: 0,
            padding: "10px 20px",
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "green",
            textDecorationColor: "green",
          },
        }}
      >
        <Tab {...a11yProps(0)} label={"Review Attendance"} />
        {roleOfEmployee?.includes("HR") && (
          <Tab {...a11yProps(1)} label={"Add Attendance"} />
        )}
      </Tabs>
    </Box>
  </Box>

  {/* Main Content */}
  <Box
    sx={{
      display: "flex",
      height: "100%", // Adjust the height as needed
      width: "100%",
    }}
  >
    <CustomTabPanel value={value} index={0}>
      <Box sx={{ width: "100%" }}>
        <ReviewAttendance />
      </Box>
    </CustomTabPanel>
    <CustomTabPanel value={value} index={1}>
      <Box sx={{ width: "100%" }}>
        <AddAttendance onTabChange={handleTabChange} />
      </Box>
    </CustomTabPanel>
  </Box>
</Box>
  );
};

export default ViewAttendaceRecords;
